import { render } from "./ProjectCard.vue?vue&type=template&id=0bb18c04&scoped=true&ts=true"
import script from "./ProjectCard.vue?vue&type=script&lang=ts"
export * from "./ProjectCard.vue?vue&type=script&lang=ts"

import "./ProjectCard.vue?vue&type=style&index=0&id=0bb18c04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bb18c04"]])

export default __exports__